<template>
  <section>
    <div v-if="!loading">
      
      <b-overlay :show="redirect" rounded="sm">
        <button
          :disabled="!checkAccepted"
          v-on:click="inviteSubmit"
          class="btn btn-fill mt-2 btn-block btn-primary"
        >
          {{ $t("NEXT") }}
        </button>
      </b-overlay>
    </div>
    <div class="p-4 text-center" v-if="loading && autoStartToken">
      <div v-if="hintMessage == 'outstandingTransaction'">
        <div v-if="!showOnThisDevice">
          1. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step1") }}.<br />
          2. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step2") }}.<br />
          3. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step3") }}.<br />
          4. {{ $t("BANKID_SE.PROCESS.outstandingTransaction.step4") }}.<br />

          <qrcode-vue
            class="qrcode mt-2 mb-4"
            v-if="autoStartToken != ''"
            :value="qrCode"
            :key="autoStartToken"
            size="200" margin="2"
            level="H"
          ></qrcode-vue>
          
          <a variant="primary" :href="bankidUrlDevice">{{ $t("SAME_DEVICE") }}</a>

        </div>
        <div class="mt-2 mb-2" v-if="showOnThisDevice">
           <a variant="primary" class="btn btn-primary btn-fill text-white" :href="bankidUrlDevice">{{ $t("SAME_DEVICE") }}</a>
          <br />
          <br />
          <a href="#" @click.prevent="otherDevice"> {{ $t("OTHER_DEVICE") }}</a>
        </div>
      </div>

      <div v-if="hintMessage != 'outstandingTransaction'">
        <h5>{{ statusMessage }}</h5>
      </div>

      <button v-on:click="cancelSubmit" class="mt-4 btn btn-secondary">
        {{ $t("CANCEL") }}
      </button>
    </div>
  </section>
</template>
<script>
import mobileDetect from "mobile-device-detect";
import QrcodeVue from "qrcode.vue";
export default {
  components: { QrcodeVue },
  props: ["code", "accepted", "email", "auth_method"],
  data() {
    return {
      redirect: false,
      device: mobileDetect,
      loading: true,
      errorMessage: "",
      auth_uuid: "",
      autoStartToken: "",
      identifier: "",
      qrCode: "",
      statusMessage: "",
      hintMessage: "outstandingTransaction",
      timer: "",
      showOnThisDevice: false,
    };
  },
  methods: {
    otherDevice: function() {
      this.showOnThisDevice = false;
    },
    reset: function() {
      clearTimeout(this.timer);
      this.loading = false;
      this.autoStartToken = "";
      this.qrCode = "";
      this.showOnThisDevice = this.device.isMobile;
      this.$emit("loading", false);
    },
    cancelSubmit: function() {
      event.preventDefault();
      let self = this;
      self.reset();
      this.$http.get(this.user.hostname + "/authenticate/cancel/" + this.auth_uuid);
    },
    hideModal: function() {
      this.$emit("hideModal");
    },
    inviteSubmit: async function() {
      this.loading = true;
      this.$emit("loading", true);
      let self = this;
      await this.$store.dispatch("errors/removeValidations");
      this.$http
        .post(this.user.hostname + "/invite/activate", {
          code: this.code,
          method: "bankid-se",
        })
        .then(function(result) {
          if (result.data.redirect == 1) {
            self.loading = false;
            self.redirect = true;
            window.location.href = result.data.request_url;
          } else {
            self.statusMessage = "";
            if(result.data.autoStartToken != undefined)
            {   
              self.autoStartToken = result.data.autoStartToken;
            }else{
              self.autoStartToken = result.data.identifier;
            }
            self.qrCode = result.data.qrCode;
            self.auth_uuid = result.data.auth_uuid;
            self.checkStatus();
          }
        })
        .catch(function() {
          self.reset();
        });
    },
    checkStatus: function() {
      let self = this;
      if (this.autoStartToken != "") {
        this.loading = true;
        this.$http
          .get(this.user.hostname + "/authenticate/status/" + this.auth_uuid)
          .then(function(result) {
            if (result.status == 200) {
              clearTimeout(self.timer);
              self.verifyAuthentication();
            }
            if (result.status == 202) {
              if(result.data.hintCode != undefined)
              {
                if(result.data.hintCode == "startFailed")
                {                
                  self.reset();
                }else{
                  self.qrCode = result.data.qrCode;         
                  self.hintMessage = result.data.hintCode;
                  self.statusMessage = self.$t("BANKID_SE.PROCESS." + result.data.hintCode);
                }
              }else{
                if(result.data == "startFailed")
                {                
                  self.reset();
                }else{
                  self.hintMessage = result.data;
                  self.statusMessage = self.$t("BANKID_SE.PROCESS." + result.data);
                }
              }
              self.timer = setTimeout(function() {
                self.checkStatus();
              }, 1500);
            }
          })
          .catch(function(error) {
            self.reset();
            self.hintMessage = error.response.data;
          });
      }
    },
    verifyAuthentication: function() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/invite/activate/result/" + this.auth_uuid)
        .then(async function(result) {
          self.$emit("activated", result.data.token);
        })
        .catch(function() {
          self.reset();
        });
    },
  },
  computed: { 
    checkAccepted() {
      return this.accepted == 1;
    },
    bankidUrlDevice() {
      if (this.device.isMobile) {
        return (
          "https://app.bankid.com/?autostarttoken=" +
          this.autoStartToken +
          "&redirect=null"
        );
      } else {
        return this.bankidUrl;
      }
    },
    bankidUrl() {
      return (
        "bankid:///?autostarttoken=" + this.autoStartToken + "&redirect=null"
      );
    },
    checkDisabled: function() {
      return this.email == "";
    },
  },
  mounted: function() {
    this.loading = false;
    this.showOnThisDevice = this.device.isMobile;
  },
};
</script>
<style></style>
